export function relatorioMenuDisponivel(respostaApi) {
	if (!respostaApi?.resultado || !respostaApi?.dados) return true

	const exibir = respostaApi.dados.exibirMenu
	if (exibir === false || exibir === 'N' || exibir === 0 || exibir === '0') return false

	return true
}